import { useTranslation } from "react-i18next";
import { SCStandardContract } from "./StandardContract.style";

const FILE_URL = "/documents/about/Типовой_договор_новая_редакция_15.10.2026.pdf";
const FILE_SIZE_MB = 1.5;
const FILE_FORMAT = "PDF";

const DocIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M14 2v6h6" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
  </svg>
);

export const StandardContract = () => {
  const { t } = useTranslation();

  return (
    <SCStandardContract>
      <h1>{t("about.standard_contract.title")}</h1>
      <p>{t("about.standard_contract.desc")}</p>

      <a
        className="doc-card"
        href={FILE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="doc-icon">
          <DocIcon />
        </div>
        <div className="doc-body">
          <p className="doc-title">{t("about.standard_contract.fileTitle")}</p>
          <p className="doc-meta">
            {FILE_FORMAT} · {FILE_SIZE_MB.toString().replace(".", ",")}{" "}
            {t("documents.size.unit")}
          </p>
        </div>
        <span className="doc-badge">{t("about.standard_contract.download")}</span>
      </a>
    </SCStandardContract>
  );
};
